import React, { useEffect, useState } from "react";
import api from "../services/api"; // pre-configured axios instance
import { Helmet } from 'react-helmet-async';
import Navbar from "../components/Navbar";
import { IMAGE_URL } from "../services/config";
import { MdContactMail, MdEdit } from "react-icons/md";
import WishlistPage from "./wishlistPane";
import { useNavigate } from "react-router-dom";

const ProfileLandingPage = () => {
  const [profile, setProfile] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await api.get("/api/profile", {
          withCredentials: true,
        });
        setProfile(response.data);
      } catch (err) {
        navigate("/login");      
      }
    };
    fetchProfile();
  },[navigate]);

  if (!profile) {
    return <div className="text-center p-6">Loading profile...</div>;
  }

  return (
    <>
      <Helmet>
        <title>{profile.first_name} - Art India Education</title>
      </Helmet>
      <Navbar />
      <main>
        {/* Top Half-Screen Banner Section */}
        <section className="relative h-[50vh] w-full overflow-hidden">
          <div className="relative w-full h-full overflow-hidden">
            {/* 🔳 Overlay */}
            <div className="absolute inset-0 bg-black/50 z-10"></div>

            {/* 🖼️ Image */}
            <img
              src="/Terms-of-use-banner-background.jpg"
              alt={`Login-banner`}
              className="absolute top-[-130%] h-[230%] w-full object-cover z-0"
            />

            {/* 🧾 Heading on top of overlay */}
            <h1 className="absolute inset-0 flex items-center justify-center text-white text-6xl font-extrabold text-center z-20 font-['EB_Garamond','Nunito','sans-serif']">
              Profile
            </h1>
          </div>
        </section>
        <section className="grid grid-cols-1 md:grid-cols-3 gap-6 p-8">
          {/* Left Panel */}
          <div className="relative bg-white p-6 rounded flex flex-col items-center text-center text-black">

            {/* ✏️ Edit Button */}
            <button
              className="absolute top-4 left-4 flex items-center space-x-1 text-[#EA7E5D] font-medium hover:underline"
              onClick={() => navigate("/profile/edit")}
            >
              <MdEdit className="text-xl" />
              <span>Edit</span>
            </button>

            <img
              src={
                profile.profile_image_url
                  ? `${IMAGE_URL}/${profile.profile_image_url}`
                  : "/default-user.png"
              }
              alt="User"
              className="w-64 h-64 rounded-full object-cover mb-4"
              onError={(e) => {
                e.target.onerror = null; // prevent looping
                e.target.src = "/default-user.png"; // fallback image
              }}
            />

            <h2 className="text-2sxl font-bold">{profile.first_name}</h2>

            <p className="text-lg mt-2 flex items-center gap-2">
              <MdContactMail className="text-[#EA7E5D] text-4xl" />
              {profile.email}
            </p>

            <div className="mt-4 pt-10">
              <p className="border-2 border-[#EA7E5D] p-5">
                <strong>Subscription Status</strong> <br />
                {profile.subscription}
              </p>
              <p className="border-2 border-[#EA7E5D] p-5 mt-4">
                <strong>Subscription Validity</strong> <br />
                {profile.validity}
              </p>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-span-2 space-y-6">
            <div className="bg-white p-6">
              <h3 className="text-3xl bg-[#EA7E5D] font-bold mb-2 p-5 text-white items-center text-center">Watchlist</h3>
              <WishlistPage />
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default ProfileLandingPage;